import { atom } from 'recoil';

export const atom_isMapReady = atom<boolean>({
	key: 'isMapReady',
	default: false,
});
